// extracted by mini-css-extract-plugin
module.exports = {"form":"profile-photo-dialog_form__z59lO","form--wide":"profile-photo-dialog_form--wide__B5wvY"};